import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X, Megaphone } from 'lucide-react';

const STORAGE_KEY = 'squidemy_pwyc_banner_dismissed';

export default function PWYCBanner() {
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    const d = localStorage.getItem(STORAGE_KEY);
    if (!d) setDismissed(false);
  }, []);

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    setDismissed(true);
  };

  if (dismissed) return null;

  return (
    <div className="relative w-full py-2.5 px-4 text-center text-[13px] sm:text-sm" style={{ background: 'linear-gradient(90deg, #7C3AED 0%, #DB2777 50%, #7C3AED 100%)' }} data-testid="pwyc-banner">
      <div className="max-w-5xl mx-auto flex items-center justify-center gap-2 flex-wrap">
        <Megaphone className="h-4 w-4 text-white/90 shrink-0 hidden sm:block" />
        <p className="text-white font-medium leading-snug">
          <span className="font-bold">Effective 01 April 2026</span>, Squidemy will now use a{' '}
          <Link to="/pwyc-policy" className="underline underline-offset-2 font-bold hover:text-white/80 transition-colors">PWYC system</Link>{' '}
          for all courses. Students can support the Academy by paying what they can — making high-quality IT education accessible, while staying sustainable.
        </p>
      </div>
      <button onClick={handleDismiss} className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded-md text-white/70 hover:text-white hover:bg-white/10 transition-colors" aria-label="Dismiss" data-testid="dismiss-pwyc-banner">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
